import styles from "./AddContactButton.module.css";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { IconAdd } from "@wwg/icons";

export function AddContactButton({ className, ...props }) {
  const { t } = useTranslation();

  return (
    <button {...props} className={classNames(styles.button, className)}>
      {t("buttons.addContact")}

      <IconAdd size={20} className={styles.icon} />
    </button>
  );
}

AddContactButton.propTypes = {};
